// extracted by mini-css-extract-plugin
export var skipAnimation = "_45-0";